export enum ReportType {
    SINGLE = 'SINGLE',
    GROUP = 'GROUP',
    COMPARISON = 'COMPARISON',
}
